module.exports = __webpack_public_path__ + "r-v3/img/speaker_on.b38c831e.svg";